import { iterable, mix, patch } from "@chorda/core";
import { Select, Option } from "./select";
export const Select2 = (props) => {
    return mix(Select(props), {
        injections: {
            options: props.options$,
            value: props.value$,
            __it: (scope) => iterable(scope.options),
        },
        reactions: {
            __it: (v) => patch({ items: v }),
            value: (v) => ({ dom: { defaultValue: v } })
        },
        events: {
            $dom: {
                change: (e, { value }) => {
                    value.$value = e.target.value;
                }
            }
        },
        defaultItem: Option2({
            option$: (scope) => scope.__it
        })
    });
};
export const Option2 = (props) => {
    return mix(Option(props), {
        injections: {
            text: props.text$,
            option: props.option$,
            key: props.key$,
        },
        reactions: {
            text: (v) => ({ text: v }),
            key: (v) => ({ dom: { value: v } })
        }
    });
};
